import { z } from "zod";
import { BALANCE_SORTS } from "@/features/leave/balance-people-rows";

/// URL search params for the balance report. All of them live in the URL (H1)
/// so a shared link opens on the screen somebody was actually looking at: the
/// page an admin had paged to, the ranking they had applied, the person they
/// had searched for.
export const leaveBalancesRouteSearchSchema = z
  .object({
    /// 1-based, bounded the same way the shore's own BalanceReportQueryDto
    /// bounds it: a page number is an offset, and an unbounded one asks
    /// Postgres to count past a billion rows before returning nothing.
    page: z.coerce.number().int().min(1).max(1_000).optional(),
    /// Which shape the report is read in. People by default: the matrix
    /// answers lookup and nothing else, and lookup is not why anybody opens
    /// this page.
    view: z.enum(["people", "types"]).optional(),
    /// Which report is open. The balance views remain the default for existing links.
    tab: z.enum(["balances", "register"]).optional(),
    /// How the people view is ranked. See `sortBalancePeopleRows` for the one
    /// honest limit: it ranks the loaded page, not the workspace.
    sort: z.enum(BALANCE_SORTS).optional(),
    /// Narrows what is already in the browser. Bounded because it arrives
    /// from the address bar and is matched as a substring.
    q: z.string().max(80).optional(),
  })
  .strict();

export type LeaveBalancesRouteSearch = z.infer<typeof leaveBalancesRouteSearchSchema>;
